export default __webpack_public_path__ + "static/media/LeaderRecommendations_Summer2021.8ed1be28.png";